import {v4 as uuid} from "uuid";
import {LabelNumberTextControl, LabelTextAreaControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import Rete from "rete";
import {tempActionSocket} from "../../sockets";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";

export class TextAnswer {

    constructor(parentComponent, textAnswerAdded, textAnswerRemoved) {
        this.parentComponent = parentComponent;
        this.onTextAnswerAdded = textAnswerAdded;
        this.onTextAnswerRemoved = textAnswerRemoved;
        this.isAdded = false;
    }

    addTextAnswer(node, textAnswerUUID = null) {
        let isAnswerNodeLoadedFromJSON = true;

        if (textAnswerUUID == null) {
            textAnswerUUID = uuid();
            isAnswerNodeLoadedFromJSON = false;
        }

        const answerControl = new LabelTextAreaControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextAnswerAnswerKey(textAnswerUUID),
            node,
            false,
            "Answer"
        );

        const scoreControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextAnswerScoreKey(textAnswerUUID),
            node,
            false,
            "Pts"
        );

        const output = new Rete.Output(
            SequenceComponentHelper.getTextAnswerOutputKey(textAnswerUUID),
            "Action",
            tempActionSocket,
            false
        );

        const removeTextAnswerControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextAnswerRemoveButtonKey(textAnswerUUID),
            node,
            false,
            () => this.onRemoveTextAnswerClick.bind(this, node, textAnswerUUID, removeTextAnswerControl, answerControl, scoreControl, output)
        );

        node
            .addControl(removeTextAnswerControl)
            .addControl(answerControl)
            .addControl(scoreControl)
            .addOutput(output);

        this.textAnswerAdded(node, textAnswerUUID);

        if (!node.data[SequenceComponentHelper.getTextAnswerOrderKey(textAnswerUUID)]) {
            node.data[SequenceComponentHelper.getTextAnswerOrderKey(textAnswerUUID)] = SequenceComponentHelper.generateTextAnswerOrder(node);
        }

        node.update();
    }

    onRemoveTextAnswerClick(node, textAnswerUUID,  removeTextAnswerControl, answerControl, scoreControl, outputControl) {
        this.removeTextAnswer(node, textAnswerUUID, removeTextAnswerControl, answerControl, scoreControl, outputControl)
            .then(r => {
                this.textAnswerRemoved(node, textAnswerUUID);
            });
    }

    async removeTextAnswer(node, textAnswerUUID,  removeTextAnswerControl, answerControl, scoreControl, outputControl) {
        node.removeControl(removeTextAnswerControl);
        node.removeControl(answerControl);
        node.removeControl(scoreControl);

        outputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
        node.removeOutput(outputControl);

        node.update();
        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getTextAnswerAnswerKey(textAnswerUUID)];
        delete node.data[SequenceComponentHelper.getTextAnswerScoreKey(textAnswerUUID)];
        delete node.data[SequenceComponentHelper.getTextAnswerOrderKey(textAnswerUUID)];
    }

    textAnswerAdded(node, addedAnswerUUID) {
        // hide 'add voice answer component'
        if(node.textAnswersIds === undefined) {
            node.textAnswersIds = [];
        }
        node.textAnswersIds.push(addedAnswerUUID);

        // add time limit of the text answer if not exist yet
        if (node.textAnswerTimeLimitId === undefined) {
            this.addTextAnswerTimeLimit(node);
        }

        this.isAdded = true;
        this.onTextAnswerAdded();
    }

    async textAnswerRemoved(node, removedAnswerUUID) {
        // remove answer uuid from node.textAnswersIds
        const indexOfRemovedAnswer = node.textAnswersIds.indexOf(removedAnswerUUID);
        if (indexOfRemovedAnswer === -1) {
            console.error(`Unexpected error occurred. There is no text answer of id '${removedAnswerUUID}' to remove.`)
        }
        node.textAnswersIds.splice(indexOfRemovedAnswer, 1);

        // remove text answer's time limit if none of text answer is left
        if (node.textAnswersIds.length === 0) {
            // remove text answer time limit
            if (node.textAnswerTimeLimitId === undefined) {
                throw new Error(`Id of time limit text answer is undefined.`);
            }
            await this.removeTextAnswerTimeLimit(node, node.textAnswerTimeLimitId);
            node.textAnswerTimeLimitId = undefined;

            this.isAdded = false;
            this.onTextAnswerRemoved();
        }
    }

    addTextAnswerTimeLimit(node, textAnswerTimeLimitUUID = null) {
        if (textAnswerTimeLimitUUID == null) {
            textAnswerTimeLimitUUID = uuid();
        }

        const timeLimitControl = new LabelNumberTextControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getTextAnswerTimeLimitKey(textAnswerTimeLimitUUID),
            node,
            false,
            "Time limit"
        );

        node.textAnswerTimeLimitId = textAnswerTimeLimitUUID;
        node.addControl(timeLimitControl);
        node.update();
    }

    async removeTextAnswerTimeLimit(node, textAnswerTimeLimitUUID) {
        // find controls and remove
        const timeLimitControl = node.controls.get(SequenceComponentHelper.getTextAnswerTimeLimitKey(textAnswerTimeLimitUUID));
        node.removeControl(timeLimitControl);

        node.update();
        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getTextAnswerTimeLimitKey(textAnswerTimeLimitUUID)];
    }
}